export default "__VITE_ASSET__24Omnb_$__"